import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import GeneralNews from './pages/GeneralNews';
import MyWatches from './pages/MyWatches';
import WatchDetail from './pages/WatchDetail';
import SignIn from './pages/SignIn';
import Nav from './components/Nav';
import RequireAuth from './components/RequireAuth';
import { AuthProvider } from './auth/AuthContext';
import { SettingsProvider } from './settings/SettingsContext';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <Nav />
          <main className="container">
            <Routes>
              {/* The news list stays public — auth only gates personal data. */}
              <Route path="/" element={<GeneralNews />} />
              <Route path="/signin" element={<SignIn />} />
              <Route
                path="/watches"
                element={
                  <RequireAuth>
                    <MyWatches />
                  </RequireAuth>
                }
              />
              <Route
                path="/watches/:id"
                element={
                  <RequireAuth>
                    <WatchDetail />
                  </RequireAuth>
                }
              />
            </Routes>
          </main>
        </BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
